import TagManager from 'react-gtm-module'

type TrackingEvent = {
  event: string
  params?: Record<string, unknown>
  [key: string]: unknown
}

export default function trackEvent({ params, ...rest }: TrackingEvent) {
  TagManager.dataLayer({
    dataLayer: {
      ...rest,
      params: {
        origin: 'Website',
        site: window.location.href,
        ...params,
      },
    },
  })
}
